var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activation"},[_c('Alert'),_c('div',{staticClass:"container-activation"},[_c('button',{staticClass:"button register",on:{"click":_vm.onLogin}},[_vm._v(" "+_vm._s(_vm.$t('activation-connection'))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }